<template>
    <div class="bq-color-page__container" >
        <b-container class="p-0 h-100">

            <b-container
                class="bq-color-page__b-container d-flex flex-column justify-content-between"
                tabindex="0"
                @keyup.enter="handleNext"
            >
                <div class="pt-2">
                    <b-row v-if="!logoHidden" class="bq-color-page__logo" align-h="start" align-v="start">
                        <logo :whitelabel-config="whitelabelConfig" />
                    </b-row>
                    <b-row class="bq-color-page__content p-4">
                        <b-col>
                            <slot />
                        </b-col>
                    </b-row>
                </div>

                <b-row class="align-self-end" align-h="end" align-v="end">
                    <b-col>
                        <nav-button
                            class="bq-color-page__nav"
                            @click="handleNext"
                            v-if="!navHidden"
                            :isLoading="isLoading"
                            :disabled="navDisabled"
                        />
                    </b-col>
                </b-row>
            </b-container>
        </b-container>

    </div>
</template>
<script>
import navButton from '@/components/ui/navButton'
import colorVariantMixin from '@/components/mixins/colorVariantMixin'
import logo from '@/components/ui/logo'
import { LOGO_HIDDEN } from '@/constants/items'

export default {
    name: 'bqColorPage',
    components: {
        navButton,
        logo
    },
    mixins: [colorVariantMixin],
    props: {
        navDisabled: {
            type: Boolean,
            default: false
        },
        navHidden: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        whitelabelConfig: {
            type: Object
        },
        currentItem: {
            type: Object
        }
    },
    computed: {
        logoHidden() {
            return !!this.currentItem?.properties?.find(prop => prop.name === LOGO_HIDDEN);
        },
    },
    methods: {
        handleNext() {
            this.$emit('click')
        }
    }
}
</script>
<style lang="scss">
.bq-color-page__container {
    &-bq-burgundy {
        background-color: $bq-burgundy;
    }

    &-bq-green {
        background-color: $bq-green;
    }

    &-bq-green--unmoved {
        background-color: $bq-green;
    }

    &-bq-blue {
        background-color: $bq-blue;
    }

    &-bq-turquoise {
        background-color: $bq-turquoise;
    }

    &-bq-orange {
        background-color: $bq-orange;
    }

    &-bq-red {
        background-color: $bq-red;
    }
}

.bq-color-page__b-container {
    outline: 0;
    color: $main-font;
    height: auto;

    @media screen and (max-width: 567px) {
        padding: 0;
        overflow-x: hidden;
    }

    @media screen and (min-width: 992px) {
        padding: 16px;
    }

    &-bq-burgundy {
        background-color: $bq-burgundy;
    }

    &-bq-green {
        background-color: $bq-green;
    }

    &-bq-green--unmoved {
        background-color: $bq-green;
    }

    &-bq-blue {
        background-color: $bq-blue;
    }

    &-bq-turquoise {
        background-color: $bq-turquoise;
    }

    &-bq-orange {
        background-color: $bq-orange;
    }

    &-bq-red {
        background-color: $bq-red;
    }
}

.bq-color-page__content {
    font-weight: 600;
}


.bq-color-page__logo {
    padding: 0 1.2em;
}

.bq-color-page__nav {
    bottom: 1.5em;
    right: 1em;
    position: fixed;
    height: 50px;
    width: 50px;
    
    @media screen and (min-width: 576px) {
        position: relative;
        right: 2em;
    }

    @media screen and (min-width: 992px) {
        right: 3em;
    }

    @media screen and (min-width: 576px) {
        height: 75px;
        width: 75px;
    }

}
</style>
